export default __webpack_public_path__ + "images/a479565835f0a22ce2cfbfc3e15e0f60-kayaking.jpg";